import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';

const data = createReducer(
  {},
  {
    [ActionTypes.FETCH_VOUCHER_ACTIVATE_SUCCESS]: (state, { payload }) => payload
  }
);

const error = createReducer(
  {
    errorMessage: {
      hasError: false,
      message: ''
    }
  },
  {
    [ActionTypes.CHECK_ACTIVATE_ERROR]: (state, { payload }) => {
      const { message } = payload.data;
      return { ...state, errorMessage: { hasMessage: true, message: message } };
    }
  }
);

export default combineReducers({
  data,
  error
});
